
import { TemplateCategory } from "./types";
import { extrajudiciaisCategory } from "./extrajudiciais";
import { previdenciariasCategory } from "./previdenciarias";
import { trabalhistasCategory } from "./trabalhistas";
import { civeisCategory } from "./civeis";
import { criminaisCategory } from "./criminais";
import { familiaSuccessoesCategory } from "./familiaSuccessoes";
import { tributarioCategory } from "./tributario";
import { empresarialCategory } from "./empresarial";
import { imobiliarioCategory } from "./imobiliario";

export const allTemplateCategories: TemplateCategory[] = [
  extrajudiciaisCategory,
  previdenciariasCategory,
  trabalhistasCategory,
  civeisCategory,
  criminaisCategory,
  familiaSuccessoesCategory,
  tributarioCategory,
  empresarialCategory,
  imobiliarioCategory
];

// Função para obter todas as categorias
export const getTemplateCategories = (): TemplateCategory[] => {
  return allTemplateCategories;
};

// Função para obter categoria por ID
export const getTemplateCategory = (id: string): TemplateCategory | undefined => {
  return allTemplateCategories.find(category => category.id === id);
};

// Função para contar total de templates
export const getTotalTemplatesCount = (): number => {
  return allTemplateCategories.reduce((total, category) => {
    return total + category.subcategories.reduce((subTotal, subcategory) => {
      return subTotal + subcategory.templates.length;
    }, 0);
  }, 0);
};

// Função para contar templates por categoria
export const getTemplatesCountByCategory = (): { [key: string]: number } => {
  const counts: { [key: string]: number } = {};
  
  allTemplateCategories.forEach(category => {
    counts[category.id] = category.subcategories.reduce((total, subcategory) => {
      return total + subcategory.templates.length;
    }, 0);
  });
  
  return counts;
};

export * from "./types";
